import { render } from "./myTask.vue?vue&type=template&id=2c41b468"
import script from "./myTask.vue?vue&type=script&lang=js"
export * from "./myTask.vue?vue&type=script&lang=js"

import "./myTask.vue?vue&type=style&index=0&id=2c41b468&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__